import { useCallback, useMemo, useState } from 'react';
import * as Yup from 'yup';
import moment from 'moment';
import { i18n } from '../../../../../language';
import { checkSubmitData } from '../../../../../utils/check';

export default function useServiceHoursCheckRules(formData) {
  const [errorMsg, setErrorMsg] = useState(null);

  const timeCheck = (value) => {
    if (value === '') {
      return true;
    } else if (value.length === 5 && value[2] === ':') {
      return moment(value, 'HH:mm').isValid();
    }
    return false;
  };

  const schema = useMemo(() => {
    return {
      startTime: Yup.string()
        .required(i18n.t('TELEVISIT_SETTING_POPUP_START_TIME_ERROR_MSG'))
        .test('checkStartTime', i18n.t('TELEVISIT_INVALID_DATE_FORMAT'), timeCheck),

      endTime: Yup.string()
        .required(i18n.t('TELEVISIT_SETTING_POPUP_END_TIME_ERROR_MSG'))
        .test('checkEndTime', i18n.t('TELEVISIT_INVALID_DATE_FORMAT'), timeCheck),
    };
  }, [formData]);

  const focusCheck = useCallback(
    (name, todayFlag) => {
      return async () => {
        try {
          const invalid = todayFlag ? moment().isSameOrAfter(moment(formData[name], 'HH:mm'), 'minute') : false;
          if (invalid) {
            setErrorMsg((oldData) => ({
              ...oldData,
              [name]: i18n.t(
                name === 'startTime'
                  ? 'SETTING_TELEVISIT_SERVICE_HOUR_INVALID_START_TIME'
                  : 'SETTING_TELEVISIT_SERVICE_HOUR_INVALID_END_TIME'
              ),
            }));
          } else {
            await checkSubmitData(Yup.object().shape({ [name]: schema[name] }), { [name]: formData[name] });

            setErrorMsg((oldData) => ({
              ...oldData,
              [name]: null,
            }));
          }
        } catch (e) {
          setErrorMsg((oldData) => ({ ...oldData, ...e }));
        }
      };
    },
    [schema, errorMsg, formData]
  );

  const checkAll = useCallback(async () => {
    try {
      await checkSubmitData(Yup.object().shape(schema), formData);
      setErrorMsg(null);
    } catch (e) {
      setErrorMsg(e);
      throw new Error(JSON.stringify(e));
    }
  }, [formData, schema]);

  return {
    checkAll,
    focusCheck,
    errorMsg,
    setErrorMsg,
    timeCheck,
  };
}
